import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Paper from '@material-ui/core/Paper';
import { GetDataStores, UpdateDataStore } from '../../fetchs';
import { Button, Grid } from '@material-ui/core';
import { green } from '@material-ui/core/colors';

import './strings.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Strings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstId: '',
      secondId: '',
      version: '',
      appLink: '',
      contactUs: '',
      learning: '',
      aboutUs: '',
      loading: false,
      uploading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: ''
    }
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false })
  }

  componentDidMount() {
    this.getStrings();
  }

  getStrings = () => {
    this.setState({ loading: true });
    GetDataStores()
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      }).then(responseJson => {
        if (responseJson.Message)
          this.setState({ errorMessage: responseJson.Message, openSnackbar: true });
        else {
          this.setState({
            firstId: responseJson.data[2].id,
            secondId: responseJson.data[3].id,
            version: responseJson.data[2].dataOne,
            appLink: responseJson.data[2].dataTwo,
            contactUs: responseJson.data[3].dataOne,
            learning: responseJson.data[3].dataTwo,
            aboutUs: responseJson.data[3].dataThree
          });
        }
      }).catch(error => {
        this.setState({ loading: false });
        console.error(error);
      });
  }

  handleFirstSave = () => {
    UpdateDataStore({
      id: this.state.firstId,
      dataOne: this.state.version,
      dataTwo: this.state.appLink
    }).then(response => {
      if (response.status === 400) {
        console.log(response);
      } else if (response.status === 200) {

      }
      return response.json();
    }).then(responseJson => {
      if (responseJson.Message)
        this.setState({ errorMessage: responseJson.Message, openSnackbar: true });
    }).catch(error => {
      console.error(error);
    });
  }

  handleSecondSave = () => {
    UpdateDataStore({
      id: this.state.secondId,
      dataOne: this.state.contactUs,
      dataTwo: this.state.learning,
      dataThree: this.state.aboutUs
    }).then(response => {
      if (response.status === 400) {
        console.log(response);
      } else if (response.status === 200) {

      }
      return response.json();
    }).then(responseJson => {
      if (responseJson.Message)
        this.setState({ errorMessage: responseJson.Message, openSnackbar: true });
    }).catch(error => {
      console.error(error);
    });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              متون
            </Typography>
            <Grid container>
              <Grid item xs={3}>
                <TextField
                  id="standard-version"
                  label="ورژن اپلیکیشن"
                  required
                  fullWidth
                  className={classes.textField}
                  value={this.state.version}
                  onChange={this.handleChange('version')}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={7}>
                <TextField
                  id="standard-appLink"
                  label="لینک دانلود اپلیکیشن"
                  required
                  fullWidth
                  className={classes.textField}
                  value={this.state.appLink}
                  onChange={this.handleChange('appLink')}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  component="span"
                  className={classes.button}
                  onClick={this.handleFirstSave}
                >
                  به روز رسانی ورژن اپلیکیشن
                </Button>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  id="standard-contactUs"
                  label="متن تماس با ما"
                  multiline
                  rows="4"
                  fullWidth
                  className={classes.textField}
                  value={this.state.contactUs}
                  onChange={this.handleChange('contactUs')}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="standard-learning"
                  label="متن آموزش اپلیکیشن"
                  multiline
                  rows="6"
                  fullWidth
                  className={classes.textField}
                  value={this.state.learning}
                  onChange={this.handleChange('learning')}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="standard-aboutUs"
                  label="متن درباره ما"
                  multiline
                  rows="6"
                  fullWidth
                  className={classes.textField}
                  value={this.state.aboutUs}
                  onChange={this.handleChange('aboutUs')}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  component="span"
                  className={classes.button}
                  onClick={this.handleSecondSave}
                >
                  به روز رسانی متن ها
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              'aria-describedby': 'message-id',
              'class': 'error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2'
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)} />
        </main>
      </React.Fragment>
    )
  };
}

Strings.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(Strings);